<template>
    <div>
        <h2>Ingredients</h2>
        <div class="card">
            <ul class="list-group list-group-flush">
                <li
                    class="list-group-item"
                    v-for="ingredient in ingredients"
                    :key="ingredient"
                    v-html="ingredient"
                ></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "RecipeIngredients",
    props: ["recipe"],
    data() {
        return {
            ingredients: this.recipe.ingredients,
        };
    },
};
</script>
<style scoped></style>
